import * as THREE from 'three'

export const randomInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const rgb = (r, g, b) => {
    return new THREE.Vector3(r, g, b);
}
